/**
 * SiteActiveCard.js
 *
 * A success card displayed when the selected site is already part of the CommunityShare network.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { CheckCircleIcon } from '@heroicons/react/24/solid';
import titleCase from '@/utils/titleCase';

SiteActiveCard.propTypes = {
  siteData: PropTypes.object.isRequired,
  summaryOnly: PropTypes.bool,
};

/**
 * Displays a message for an active site in the network.
 *
 * @param {object} props - Component props.
 * @returns {JSX.Element} The rendered active site card.
 */
function SiteActiveCard(props) {
  const { siteData, summaryOnly = false } = props;
  return (
    <div className="bg-green-100 border border-cs-green-500 rounded-2xl flex gap-2 items-start px-4 pt-4 pb-5">
      <CheckCircleIcon className="w-[22px] h-[22px] text-cs-green-500 shrink-0 mt-0.5" />
      <div className="flex flex-col gap-4 flex-1">
        {summaryOnly ? (
          <p className="font-semibold text-base text-gray-700 leading-[1.2] tracking-[-0.17px]">
            Your site is part of the CommunityShare Network
          </p>
        ) : (
          <>
            <div className="flex flex-col gap-4">
              <p className="font-semibold text-base text-gray-700 leading-[1.2] tracking-[-0.17px]">
                Great news – your site is already part of the CommunityShare network
              </p>
              <p className="text-base text-gray-700 leading-[1.2] tracking-[-0.16px]">
                Please check that the information below is correct.
              </p>
            </div>
            <div className="text-base font-semibold text-gray-700 leading-[1.2] tracking-[-0.17px]">
              <p>{siteData.name}</p>
              <p>{titleCase(siteData.addressLine1 || '')}</p>
              <p>{siteData.city} {siteData.state}, {siteData.zipCode}</p>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default SiteActiveCard;
